// extracted by mini-css-extract-plugin
export default {"h1":"dFVTwQa4RiJt4nn1867Y","bold":"lYjCg3Kk3JFjBtdhqAp3","pink":"zzgCm4g1SBgl7o3l6Z0j"};